const getSellingPlanPrice = (variant, sellingPlanId, priceName = 'price') => {
  if (!sellingPlanId || sellingPlanId === '') return variant[priceName];

  const sellingPlanAllocation = variant.selling_plan_allocations.find(
    allocation => allocation.selling_plan_id === Number(sellingPlanId)
  );

  if (!sellingPlanAllocation) return variant[priceName];

  return sellingPlanAllocation[priceName];
};

export default getSellingPlanPrice;
